import { render, staticRenderFns } from "./FirstStepComponent.vue?vue&type=template&id=61d418ba&scoped=true"
import script from "./FirstStepComponent.vue?vue&type=script&lang=js"
export * from "./FirstStepComponent.vue?vue&type=script&lang=js"
import style0 from "./FirstStepComponent.vue?vue&type=style&index=0&id=61d418ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d418ba",
  null
  
)

export default component.exports